import React, { ReactElement } from "react";
import { useTagsSettingsQuery } from "../../__generated__/api";
import EditableControl, { ControlType } from "../editable-text/EditableText";
import { Filters } from "../filters/Filters";

export enum TagType {
    TICKET_TAGS = "TICKET_TAGS"
}

export interface TagsProps {
    value?: string[];
    onChange?: (tags: string[]) => void;
    isReadOnly?: boolean;
    shouldShowDropdown?: boolean;
    className?: string;
    toggleClassName?: string;
    toggleText?: string
}
export default function Tags({
    value, onChange, isReadOnly, className, toggleClassName, toggleText, shouldShowDropdown,
}: TagsProps): ReactElement {
    const { data, loading } = useTagsSettingsQuery();
    const tags = data?.settings?.customization?.tags;
    if (!loading || !tags) {
        <small className="text-light">...loading</small>;
    }
    if (!tags) {
        return (
            <small className="text-light">Add Tags</small>
        );
    }
    if (shouldShowDropdown) {
        return (
            <Filters
                toggleText={toggleText}
                isMulti
                categories={tags.map(tag => ({
                    id: tag,
                    name: tag,
                }))}
                className={className}
                toggleClassName={toggleClassName}
                selectedCategories={
                    new Set(value)
                }
                onSelected={current => (
                    onChange?.(Array.from(current))
                )}
            />
        );
    }
    return (
        <EditableControl
            placeholder="Add tags"
            isReadOnly={isReadOnly}
            type={ControlType.MULTI_SELECT_TAGS}
            options={tags.map(tag => ({
                label: tag,
                value: tag,
            }))}
            value={value}
            onChange={values => onChange?.(values as string[])}
        >
            {!tags ? <small className="text-light">Add Tags</small> : undefined}
        </EditableControl>
    );
}

Tags.defaultProps = {
    value: undefined,
    onChange: undefined,
    isReadOnly: undefined,
    shouldShowDropdown: undefined,
    className: undefined,
    toggleClassName: undefined,
    toggleText: undefined,
};
